import withLabel from './withLabel';

export default withLabel;
